import { GoogleSSOButton } from "src/components/GoogleSSOButton";
import { ShareButton } from "src/components/ShareButton";
import {
  TryTemplateButton,
  tryTemplateActions,
} from "src/components/TryTemplateButton";
import {
  TemplateBookmarkButton,
  TemplateBookmarkActions,
} from "src/components/TemplateBookmarkButton";
import { Suspense } from "react";
import styles from "./TemplateCTAs.module.css";
import { Template } from "src/types";

type TemplateCTAsProps = {
  template: Template;
  isLoggedIn: boolean;
  hasBookmarking: boolean;
  templateBookmarkActions: TemplateBookmarkActions;
  tryTemplateActions: tryTemplateActions;
  align?: "start" | "center";
  buttonSize?: "small" | "medium";
  hasTemplatePage: boolean;
  apiHostName?: string;
};

/**
 * TemplateCTAs is a component that displays a list of buttons for a template.
 * Buttons include:
 * - TemplateBookmarkButton
 * - ShareButton
 * - GoogleSSOButton
 * - TryTemplateButton
 */
export const TemplateCTAs = ({
  template,
  isLoggedIn,
  align = "start",
  hasBookmarking,
  templateBookmarkActions,
  tryTemplateActions,
  buttonSize,
  hasTemplatePage,
  apiHostName,
}: TemplateCTAsProps) => {
  const showTemplateBookmark = isLoggedIn && hasBookmarking;
  const products = template.products ?? [];
  const isZapTemplate = products.length === 1 && products[0]?.slug === "zaps";

  return (
    <Suspense>
      <div className={styles.buttons} style={{ justifyContent: align }}>
        {showTemplateBookmark && template.id && (
          <TemplateBookmarkButton
            id={template.id}
            slug={template.slug}
            isZapTemplate={isZapTemplate}
            buttonVariant="button"
            templateBookmarkActions={templateBookmarkActions}
          />
        )}
        {isLoggedIn && template.id && hasTemplatePage && (
          <ShareButton apiHostName={apiHostName} template={template} />
        )}
        {!isLoggedIn && (
          <GoogleSSOButton
            slug={template.slug}
            size={buttonSize}
            templateId={template.id ?? ""}
          >
            Continue with Google
          </GoogleSSOButton>
        )}
        <TryTemplateButton
          template={template}
          tryTemplateActions={tryTemplateActions}
          size={buttonSize}
          allowMobileFullWidth={!isLoggedIn}
          webIntentUrl={template.webIntentUrl}
        >
          {isLoggedIn ? "Try it" : "Use this template"}
        </TryTemplateButton>
      </div>
    </Suspense>
  );
};
